var exports = {
  "Xg": "sidebarSearch__Mlm--x",
  "ok": "sidebarSearchWrapper__K-ZfhK",
  "TQ": "emptySearchResultsItem__0JPUos",
};

module.exports = exports;
